export default __webpack_public_path__ + "static/media/option-metal.e8844949.svg";